// extracted by css-extract-rspack-plugin
export default {"reference":"aQDUaO"};